
    
    import { lazy } from "react";
    import loadable, { lazy as loadableLazy } from "@modern-js/runtime/loadable"
  
    
    
    import { createShouldRevalidate, handleRouteModule,  handleRouteModuleError} from '@modern-js/runtime/router';
  
    import RootLayout from '@_modern_js_src/routes/layout'
    
    
    
    
    
    if(typeof document !== 'undefined'){
      window._routeModules = {}
    }
  
    
    export const routes = [
  {
  "path": "/",
  "children": [
    {
      "_component": "@_modern_js_src/routes/page",
      "index": true,
      "id": "page",
      "type": "nested",
      "lazyImport": () => import(/* webpackChunkName: "page" */  '@_modern_js_src/routes/page').then(routeModule => handleRouteModule(routeModule, "page")).catch(handleRouteModuleError),
      "component": lazy(() => import(/* webpackChunkName: "page" */  '@_modern_js_src/routes/page').then(routeModule => handleRouteModule(routeModule, "page")).catch(handleRouteModuleError))
    }
  ],
  "isRoot": true,
  "_component": "@_modern_js_src/routes/layout",
  "id": "layout",
  "type": "nested",
  "lazyImport": () => import('@_modern_js_src/routes/layout').then(routeModule => handleRouteModule(routeModule, "layout")).catch(handleRouteModuleError),
  "component": RootLayout
},
];
  